export enum PaymentMode {
  CreditCardSetup = 'credit-card-setup',
  DebitOrderSetup = 'debit-order-setup',
  DigitalWalletSetup = 'digital-wallet-setup',
  DefinedInPaymentElement = 'defined-in-payment-element',
}
